import React from 'react'

type ImageMarkerPropsType = {
  src: string
  height: number
  width: number
}

const ImageMarker: React.FC<ImageMarkerPropsType> = ({ src, height, width }) => {
  if (!src || !height || !width) return <></>

  const imgStyle = {
    backgroundSize: 'cover',
    width: width + 'px',
    height: height + 'px',
  }

  return <img style={imgStyle} src={src} />
}

export default ImageMarker
